var _rect, _circle, _circle2, _path, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear_1605_4110)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 34.5,
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 2.16568,
    strokeDasharray: "15 10"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 25.5,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5957 35.791C33.3809 35.791 34.0781 35.9404 34.6875 36.2393C35.3027 36.5381 35.7861 36.9775 36.1377 37.5576C36.4893 38.1377 36.665 38.8525 36.665 39.7021C36.665 40.6279 36.4717 41.4277 36.085 42.1016C35.7041 42.7695 35.1328 43.2822 34.3711 43.6396C33.6152 43.9971 32.6719 44.1758 31.541 44.1758C30.8672 44.1758 30.2314 44.1172 29.6338 44C29.042 43.8887 28.5234 43.7158 28.0781 43.4814V41.1348C28.5234 41.3691 29.0566 41.5684 29.6777 41.7324C30.3047 41.8906 30.8936 41.9697 31.4443 41.9697C31.9834 41.9697 32.4375 41.8994 32.8066 41.7588C33.1758 41.6123 33.4541 41.3896 33.6416 41.0908C33.835 40.7861 33.9316 40.3994 33.9316 39.9307C33.9316 39.3037 33.7207 38.8232 33.2988 38.4893C32.877 38.1553 32.2295 37.9883 31.3564 37.9883C31.0225 37.9883 30.6738 38.0205 30.3105 38.085C29.9531 38.1494 29.6543 38.2139 29.4141 38.2783L28.333 37.6982L28.8164 31.1504H35.7861V33.4531H31.1982L30.9609 35.9756C31.1602 35.9346 31.377 35.8936 31.6113 35.8525C31.8457 35.8115 32.1738 35.791 32.5957 35.791ZM47.1328 37.5752C47.1328 38.6123 47.0508 39.5381 46.8867 40.3525C46.7285 41.167 46.4707 41.8584 46.1133 42.4268C45.7617 42.9951 45.2988 43.4287 44.7246 43.7275C44.1504 44.0264 43.4531 44.1758 42.6328 44.1758C41.6016 44.1758 40.7549 43.915 40.0928 43.3936C39.4307 42.8662 38.9414 42.1104 38.625 41.126C38.3086 40.1357 38.1504 38.9521 38.1504 37.5752C38.1504 36.1865 38.2939 35 38.5811 34.0156C38.874 33.0254 39.3486 32.2666 40.0049 31.7393C40.6611 31.2119 41.5371 30.9482 42.6328 30.9482C43.6582 30.9482 44.502 31.2119 45.1641 31.7393C45.832 32.2607 46.3271 33.0166 46.6494 34.0068C46.9717 34.9912 47.1328 36.1807 47.1328 37.5752ZM40.8486 37.5752C40.8486 38.5537 40.9014 39.3711 41.0068 40.0273C41.1182 40.6777 41.3027 41.167 41.5605 41.4951C41.8184 41.8232 42.1758 41.9873 42.6328 41.9873C43.084 41.9873 43.4385 41.8262 43.6963 41.5039C43.96 41.1758 44.1475 40.6865 44.2588 40.0361C44.3701 39.3799 44.4258 38.5596 44.4258 37.5752C44.4258 36.5967 44.3701 35.7793 44.2588 35.123C44.1475 34.4668 43.96 33.9746 43.6963 33.6465C43.4385 33.3125 43.084 33.1455 42.6328 33.1455C42.1758 33.1455 41.8184 33.3125 41.5605 33.6465C41.3027 33.9746 41.1182 34.4668 41.0068 35.123C40.9014 35.7793 40.8486 36.5967 40.8486 37.5752Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 20,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_4110",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.771913,
    stopColor: "#FF8855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAB1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip50);
export default __webpack_public_path__ + "static/media/chip50.b0e747f9a591f03b6b1c5c2a99d0f50a.svg";
export { ForwardRef as ReactComponent };